import { Flex } from 'antd';
import { forwardRef } from 'react';

const MyFlex = forwardRef(
  ({ block, children, gap = 10, className, ...otherProps }, ref) => {
    return (
      <Flex
        ref={ref}
        {...otherProps}
        gap={gap}
        className={`${block ? 'full_width' : ''} ${className}`}
      >
        {children}
      </Flex>
    );
  }
);

export default MyFlex;
